import { fetchOrder } from 'actions/entities/orders/fetchOrder';
import { fetchPayment } from 'actions/entities/payments/payments';
import { setGatewayOrigin, setGatewaySource } from 'actions/ui/ui';
import { Footer } from 'components/Footer/Footer';
import { Header } from 'components/Header/Header';
import { Heading } from 'components/Heading/Heading';
import { RedirectToPay } from 'components/Routes/RedirectToPay/RedirectToPay';
import { Spinner } from 'components/Spinner/Spinner';
import { GATEWAY_DUPLICATED_ROUTE } from 'constants/routes';
import { ReactComponent as RemoveCircle } from 'icons/remove-circle.svg';
import isEmpty from 'lodash/isEmpty';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import type { RootState } from 'reducers/types';
import { getOrder } from 'selectors/entities/order/order';
import { hasPayment as selectHasPayment } from 'selectors/entities/payment/payment';
import { useDispatch } from 'store/configureStore';
import { useTranslations } from 'utils/translations/useTranslations';

function PrefillOrderAndPay() {
  const [isFetching, setIsFetching] = useState(true);
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const hasPayment = useSelector((state: RootState) => selectHasPayment(state));
  const i18n = useTranslations();
  const order = useSelector((state: RootState) => getOrder(state));
  const { orderId } = useParams<{ orderId: string }>();

  useEffect(() => {
    const fetchData = async () => {
      const token = searchParams.get('token');
      const platform = searchParams.get('platform');

      dispatch(setGatewayOrigin());
      if (platform) {
        dispatch(setGatewaySource(platform));
      }

      try {
        if (!orderId || !token) {
          return;
        }

        await dispatch(fetchOrder({ orderId, token }));
        await dispatch(fetchPayment({ orderId, token }));
      } finally {
        setIsFetching(false);
      }
    };

    fetchData();
  }, [dispatch, orderId, searchParams]);

  if (isFetching) {
    return <Spinner />;
  }
  if (hasPayment) {
    return <Navigate to={GATEWAY_DUPLICATED_ROUTE} />;
  }

  return isEmpty(order) ? (
    <div className="Site">
      <Header />
      <section className="ErrorPage">
        <RemoveCircle />
        <Heading as="h1" size="huge" className="ErrorPage-title">
          {i18n.t('prefillOrderAndPay.errorTitle')}
        </Heading>
        <p className="fontSize-lg marginBottom-sm">
          {i18n.t('prefillOrderAndPay.notFound')}
        </p>
      </section>
      <Footer />
    </div>
  ) : (
    <RedirectToPay cleanSearch={true} />
  );
}

export { PrefillOrderAndPay };
